module.exports = __webpack_public_path__ + "media/images/flags/SO-d17444c18e58df0b37806f9bde8e3bab.svg";